const validAreaCodes = [
  "201",
  "202",
  "205",
  "203",
  "206",
  "207",
  "208",
  "209",
  "210",
  "212",
  "213",
  "214",
  "215",
  "216",
  "217",
  "218",
  "219",
  "224",
  "225",
  "228",
  "229",
  "231",
  "234",
  "239",
  "240",
  "248",
  "251",
  "252",
  "253",
  "254",
  "256",
  "260",
  "262",
  "267",
  "269",
  "270",
  "272",
  "276",
  "281",
  "301",
  "302",
  "303",
  "304",
  "305",
  "307",
  "308",
  "309",
  "310",
  "312",
  "313",
  "314",
  "315",
  "316",
  "317",
  "318",
  "319",
  "320",
  "321",
  "323",
  "325",
  "330",
  "331",
  "334",
  "336",
  "337",
  "339",
  "346",
  "347",
  "351",
  "352",
  "360",
  "361",
  "364",
  "385",
  "386",
  "401",
  "402",
  "404",
  "405",
  "406",
  "407",
  "408",
  "409",
  "410",
  "412",
  "413",
  "414",
  "415",
  "417",
  "419",
  "423",
  "424",
  "425",
  "430",
  "432",
  "434",
  "435",
  "440",
  "442",
  "443",
  "458",
  "464",
  "469",
  "470",
  "475",
  "478",
  "479",
  "480",
  "484",
  "501",
  "502",
  "503",
  "504",
  "505",
  "507",
  "508",
  "509",
  "510",
  "512",
  "513",
  "515",
  "516",
  "517",
  "518",
  "520",
  "530",
  "531",
  "534",
  "539",
  "540",
  "541",
  "551",
  "557",
  "559",
  "561",
  "562",
  "563",
  "564",
  "567",
  "570",
  "571",
  "573",
  "574",
  "575",
  "580",
  "585",
  "586",
  "601",
  "602",
  "603",
  "605",
  "606",
  "607",
  "608",
  "609",
  "610",
  "612",
  "614",
  "615",
  "616",
  "617",
  "618",
  "619",
  "620",
  "623",
  "626",
  "627",
  "628",
  "629",
  "630",
  "631",
  "636",
  "641",
  "646",
  "650",
  "651",
  "657",
  "660",
  "661",
  "662",
  "667",
  "669",
  "678",
  "679",
  "681",
  "682",
  "689",
  "701",
  "702",
  "703",
  "704",
  "706",
  "707",
  "708",
  "712",
  "713",
  "714",
  "715",
  "716",
  "717",
  "718",
  "719",
  "720",
  "724",
  "725",
  "727",
  "730",
  "731",
  "732",
  "734",
  "737",
  "740",
  "747",
  "754",
  "757",
  "760",
  "762",
  "763",
  "764",
  "765",
  "769",
  "770",
  "772",
  "773",
  "774",
  "775",
  "779",
  "781",
  "785",
  "786",
  "801",
  "802",
  "803",
  "804",
  "805",
  "806",
  "808",
  "810",
  "812",
  "812",
  "813",
  "814",
  "815",
  "816",
  "817",
  "818",
  "828",
  "830",
  "831",
  "832",
  "843",
  "845",
  "847",
  "848",
  "850",
  "856",
  "857",
  "858",
  "859",
  "860",
  "862",
  "863",
  "864",
  "865",
  "870",
  "872",
  "878",
  "901",
  "903",
  "904",
  "906",
  "907",
  "908",
  "909",
  "910",
  "912",
  "913",
  "914",
  "915",
  "916",
  "917",
  "918",
  "919",
  "920",
  "925",
  "928",
  "929",
  "930",
  "931",
  "935",
  "936",
  "937",
  "938",
  "940",
  "941",
  "947",
  "949",
  "951",
  "952",
  "954",
  "956",
  "959",
  "970",
  "971",
  "972",
  "973",
  "975",
  "978",
  "979",
  "980",
  "984",
  "985",
  "989"
];
const invalidSevenDigits = [
  "0000000",
  "1111111",
  "2222222",
  "3333333",
  "4444444",
  "5555555",
  "6666666",
  "7777777",
  "8888888",
  "9999999"
];

export const validateRequiredFiled = value => {
  let error;
  if (!value) {
    error = "This field is required";
  }
  return error;
};

export const hasFieldError = (errors, touched) => {
  if (Object.keys(touched).length === 0 && touched.constructor === Object) {
    return true;
  }

  if (Object.keys(errors).length === 0 && errors.constructor === Object) {
    return false;
  }

  return true;
};

export const hasEmptyField = (questions, values) => {
  for (let i = 0; i < questions.length; i++) {
    if (!values[questions[i].metaKey]) {
      return true;
    }
  }

  return false;
};

export const validatePhoneNumber = value => {
  let error;
  let phone = value.replace(/[^\d]/g, "");
  if (phone.length === 10) {
    if (!validAreaCodes.includes(phone.substring(0, 3))) {
      error = "Area code not recognized";
    }
    if (invalidSevenDigits.includes(phone.substring(3, 10))) {
      error =
        "Last 7 digits are same not accepted. Please enter a valid phone number";
    }
    if (phone.substring(6, 10) === "0000") {
      error =
        "Last 4 digits are 0s not accepted. Please enter a valid phone number";
    }
  }
  return error;
};
